<template>
  <v-container>
    <v-card class="pa-4">
      <v-card-title>Extractos Registrados</v-card-title>
      <v-data-table
        :headers="headers"
        :items="extractos"
        :items-per-page="10"
        class="elevation-1"
        dense
      ></v-data-table>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      extractos: [],
      headers: [
        { text: 'Fecha', value: 'fecha_movimiento' },
        { text: 'Banco', value: 'cuenta_bancaria.banco.nombre' },
        { text: 'Cuenta', value: 'cuenta_bancaria.numero' },
        { text: 'Descripción', value: 'descripcion' },
        { text: 'Crédito', value: 'credito' },
        { text: 'Débito', value: 'debito' },
      ],
    }
  },
  mounted() {
    this.obtenerExtractos()
  },
  methods: {
    async obtenerExtractos() {
      const data=[
  {
    "id": 1,
    "fecha_movimiento": "2025-06-01",
    "descripcion": "Depósito en ventanilla",
    "credito": 500.00,
    "debito": 0.00,
    "cuenta_bancaria": {
      "id": 1,
      "numero": "123456789",
      "banco": {
        "id": 1,
        "nombre": "BNB"
      }
    }
  },
  {
    "id": 2,
    "fecha_movimiento": "2025-06-03",
    "descripcion": "Pago de servicio",
    "credito": 0.00,
    "debito": 150.00,
    "cuenta_bancaria": {
      "id": 1,
      "numero": "123456789",
      "banco": {
        "id": 1,
        "nombre": "BNB"
      }
    }
  },
  {
    "id": 3,
    "fecha_movimiento": "2025-06-05",
    "descripcion": "Transferencia recibida",
    "credito": 250.00,
    "debito": 0.00,
    "cuenta_bancaria": {
      "id": 2,
      "numero": "987654321",
      "banco": {
        "id": 2,
        "nombre": "Banco del Sur"
      }
    }
  }
]

      // const res = await fetch('http://localhost:8080/api/extractos')
      // this.extractos = await res.json()
      this.extractos=data
    },
  },
}
</script>
